import React, { useContext, useState } from 'react'
import { Button, Chip, Menu, MenuItem } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { FORMS, MANUAL_FORMS } from './catalogue'
import { requestForEntry } from './liveUi'
import { EPCRContext } from '../EPCR'
import RequestDopsDialog from '../../dops/RequestDopsDialog'

// "Request DOPS" for a completed intervention whose form is DOPS-eligible
// (catalogue FORMS[*].dops). Needs a saved record - the server checks the
// requester was involved and the entry still exists.
const RequestDopsButton = ({ section, entry, formKey }) => {
  const { formID } = useContext(EPCRContext)
  const [open, setOpen] = useState(false)
  const form = FORMS[formKey]
  if (!form?.dops || !formID || !entry?.entryId || entry.detailsPending) return null
  return (
    <>
      <Button
        size="small"
        variant="text"
        onClick={(e) => {
          e.stopPropagation()
          setOpen(true)
        }}
      >
        Request DOPS
      </Button>
      {/* MUI portals bubble React clicks to the entry card - contain them */}
      <span onClick={(e) => e.stopPropagation()}>
        <RequestDopsDialog
          open={open}
          onClose={() => setOpen(false)}
          epcrID={formID}
          entryId={entry.entryId}
          section={section}
          procedureLabel={form.title}
        />
      </span>
    </>
  )
}

// "Details needed" chip + Add/Edit details for an entry created from a live
// console tap (or a manual critical care form). Tracked medicine
// administrations are amended through their own flow instead.
export const LiveEntryActions = ({ section, entry, onOpen }) => {
  const request = requestForEntry(section, entry)
  if (!request || entry.medicineLogId) {
    return entry?.detailsPending ? (
      <Chip size="small" color="warning" label="Details needed" />
    ) : null
  }
  return (
    <>
      {entry.detailsPending && (
        <Chip size="small" color="warning" label="Details needed" />
      )}
      <Button
        size="small"
        variant={entry.detailsPending ? 'contained' : 'outlined'}
        color={entry.detailsPending ? 'warning' : 'primary'}
        onClick={(e) => {
          e.stopPropagation()
          onOpen(request)
        }}
      >
        {entry.detailsPending ? 'Add details' : 'Edit details'}
      </Button>
      <RequestDopsButton section={section} entry={entry} formKey={request.formKey} />
    </>
  )
}

// "Add critical care intervention" - MANUAL_FORMS for the section, opened
// in LiveDetailForm to create a new entry.
export const ManualInterventionButton = ({ section, onOpen, fullWidth }) => {
  const [anchor, setAnchor] = useState(null)
  const rows = MANUAL_FORMS[section] || []
  if (!rows.length) return null
  return (
    <>
      <Button
        variant="contained"
        color="error"
        startIcon={<AddIcon />}
        onClick={(e) => setAnchor(e.currentTarget)}
        fullWidth={fullWidth}
      >
        Add critical care intervention
      </Button>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {rows.map((row) => (
          <MenuItem
            key={`${row.form}-${row.label}`}
            sx={{ minHeight: 44 }}
            onClick={() => {
              setAnchor(null)
              onOpen({
                section,
                formKey: row.form,
                create: {
                  moduleName: row.moduleName,
                  prefill: row.prefill,
                  liveAction: row.liveAction,
                },
              })
            }}
          >
            {row.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
